import API_BASE_URL from '../config/apiConfig';
import createApiClient from '../config/apiClient';

const apiClient = createApiClient(API_BASE_URL);
const API_URL = '/section-items';

const sectionItemService = {
  // Customer route - lấy tất cả section items cho homepage trong 1 request (tối ưu)
  async getHomepage() {
    try {
      const response = await apiClient.get(`${API_URL}/customer/homepage`);
      return response.data;
    } catch (error) {
      console.error('Error fetching homepage section items:', error);
      throw error;
    }
  },

  // Customer route - lấy tất cả section items cho service page trong 1 request (tối ưu)
  async getServicePage(pageSlug) {
    try {
      const response = await apiClient.get(`${API_URL}/customer/service-page/${pageSlug}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching service page section items:', error);
      throw error;
    }
  },

  // Customer route - lấy danh sách items theo type (public)
  // pageContext: 'home' | 'service' | 'all'
  // pageSlug: service slug (ví dụ: 'security-assessment-code-review') hoặc 'home'
  async getByType(type, pageContext = null, pageSlug = null) {
    try {
      const params = {};
      if (pageContext) params.pageContext = pageContext;
      if (pageSlug) params.pageSlug = pageSlug;
      
      const response = await apiClient.get(`${API_URL}/customer/${type}`, { params });
      return response.data;
    } catch (error) {
      console.error(`Error fetching section items for type ${type}:`, error);
      throw error;
    }
  },

  // Admin routes
  // Lấy danh sách tất cả items (có thể filter theo sectionType)
  async getAll(sectionType = null) {
    try {
      const params = sectionType ? { sectionType } : {};
      const response = await apiClient.get(`${API_URL}/admin`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching section items:', error);
      throw error;
    }
  },

  // Lấy item theo ID
  async getById(id) {
    try {
      const response = await apiClient.get(`${API_URL}/admin/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching section item:', error);
      throw error;
    }
  },

  // Tạo item mới
  async create(data) {
    try {
      const response = await apiClient.post(`${API_URL}/admin`, data);
      return response.data;
    } catch (error) {
      console.error('Error creating section item:', error);
      throw error;
    }
  },

  // Cập nhật item
  async update(id, data) {
    try {
      const response = await apiClient.put(`${API_URL}/admin/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating section item:', error);
      throw error;
    }
  },

  // Xóa item
  async delete(id) {
    try {
      const response = await apiClient.delete(`${API_URL}/admin/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting section item:', error);
      throw error;
    }
  }
};

export default sectionItemService;
